import { GenerateProductVariantSKUAndShortIdResponse } from "../apis/useGenerateProductVariantSKUAndShortId";
import { ProductVariantFormValue } from "../components/forms/ProductDetailsForm/ProductDetailsForm.types";

export const createInitialProductFormVariantItem = (
  colorAttributeValueId: string,
  sizeAttributeValueIds: string[],
  skuAndShortId: GenerateProductVariantSKUAndShortIdResponse
): ProductVariantFormValue => ({
  colorAttributeValueId,
  sku: skuAndShortId.sku,
  shortId: skuAndShortId.shortId,
  name: "",
  shortTitle: "",
  barcodes: sizeAttributeValueIds.map((sizeId) => ({
    sizeAttributeValueId: sizeId,
    value: ""
  })),
  images: [],
  badgeId: null,
  preview: null,
  compressedPreview: null,
  weight: null,
  volume: null,
  allowSellingBelowBuyingPrice: false,
  buyingPrice: null,
  merchantPrice: null,
  standardPrice: null,
  intermediateResellerPrice: null,
  confirmedResellerPrice: null,
  influencerPrice: null,
  recommendedSellingPrice: null,
  discount: null,
  discountAmount: null,
  activeDiscountType: "percentage",
  suggestionDiscount: null,
  suggestionDiscountAmount: null,
  activeSuggestionDiscountType: "percentage",
  activeCommissionType: "percentage",
  commission: null,
  commissionPercentage: null,
  influencerCommissionPercentage: null,
  variantsBoughtTogether: [],
  bulkDiscounts: []
});
